import * as yup from 'yup'

export const requiredMessage = 'This field is required'
const shape = obj => yup.object().shape(obj)
const validations = {
  user: shape({
    name: yup.string().required(requiredMessage),
    email: yup.string().required(requiredMessage).email(),
    password: yup.string().required(requiredMessage).min(8),
  }),
  userWithoutPass: shape({
    name: yup.string().label('Name').required(requiredMessage),
    email: yup.string().label('Email').required(requiredMessage).email(),
  }),
  passwordConfirmation: yup
    .string()
    .required(requiredMessage)
    .min(6)
    .test(
      'confirm-password',
      'Confirmation password is not the same as password',
      function (confirmPassword) {
        return this.parent.user.password === confirmPassword
      }
    ),
}

export default validations
